import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const GiftOrderSuccess = ({ urls }) => (
  <Fragment>
    <p>
      <strong>Merci pour votre achat et votre confiance.</strong>
    </p>
    <p>
      Vous allez recevoir par e-mail le bon cadeau avec votre message
      personnalisé si vous l’avez spécifié.
    </p>
    <p>
      Vous pourrez ainsi directement l’imprimer pour le donner en main propre ou
      transférer l’e-mail directement au bénéficiaire.
    </p>
    <p>
      Vous avez également la possibilité de télécharger le bon cadeau en vous
      rendant <a href={urls.orderURL}> sur la page dédiée à votre bon cadeau</a>
      .
    </p>
  </Fragment>
)

GiftOrderSuccess.propTypes = {
  urls: PropTypes.object.isRequired
}

export default GiftOrderSuccess
